import React, { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Clock } from "lucide-react";
import { api, formatApiError } from "../../lib/apiClient";
import { Button } from "../ui/button";

export function DiagnosisRegenCard({ caseId, regen, onRegenerated }) {
  const [busy, setBusy] = useState(false);
  if (!regen) return null;
  if (regen.in_review) {
    return (
      <div className="border border-sky-300 bg-sky-50 text-sky-900 text-xs p-3 flex gap-2" data-testid="diagnosis-regen-in-review">
        <Clock className="w-4 h-4 shrink-0" />
        Su diagnóstico actualizado con el nuevo presupuesto se está preparando y pasará por revisión humana. Mientras tanto ve aquí la versión anterior.
      </div>
    );
  }
  if (!regen.available) return null;
  const run = async () => {
    if (!window.confirm("Se generará un nuevo diagnóstico con su presupuesto corregido y un revisor lo aprobará antes de que lo vea. Esta actualización gratuita solo se puede usar una vez por caso. ¿Continuar?")) return;
    setBusy(true);
    try {
      await api.post(`/cases/${caseId}/diagnosis/regenerate`);
      toast.success("Actualización solicitada. Le avisaremos cuando el revisor la apruebe.");
      onRegenerated?.();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "No se pudo solicitar la actualización");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border border-primary/30 bg-primary/5 p-3 flex flex-wrap items-center justify-between gap-3" data-testid="diagnosis-regen-card">
      <p className="text-xs text-gray-800">
        <strong>Corrigió su presupuesto.</strong> Puede actualizar el diagnóstico con el nuevo valor sin repetir el proceso. Gratis, una vez por caso, con revisión humana.
        {regen.last_failed_at && <span className="block text-rose-700 mt-1" data-testid="diagnosis-regen-failed">El intento anterior no se completó por un error técnico; no se descontó su actualización gratuita. Puede intentarlo de nuevo.</span>}
      </p>
      <Button size="sm" onClick={run} disabled={busy} className="h-8 rounded-sm text-xs" data-testid="diagnosis-regen-btn">
        <RefreshCw className="w-3.5 h-3.5 mr-1.5" />{busy ? "Solicitando…" : "Actualizar diagnóstico"}
      </Button>
    </div>
  );
}
